import React, { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import DashboardNav from '../../components/Nav/DashboardNav';
import Footer from '../../components/Footer/Footer';
import Review from '../../components/Review/Review';
import { useNavigate, useLocation } from 'react-router-dom';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import ratedPeople from '../assets/herosectionimage.png';
import smallRatedPeople from '../assets/herosectionimage.png';
import Whatsappimage from '../assets/whatsapp.svg'
import locationicon from '../assets/locationicon.svg'
import instagram from '../../components/Review/assets/instagram.svg'
import Nav from '../../components/Nav/Nav'
import fullStar from '../../components/Review/assets/fullStar.svg'
import { ArrowDown } from 'lucide-react';
import { ArrowUp } from 'lucide-react';


const VendorDashboard = ({ vendorOwnerData, reviewData, user }) => {
  const location = useLocation();
  // const { user, vendor, filteredVendorData = [] } = location.state || {};
  const navigate = useNavigate();
  const vendor = vendorOwnerData;          // The vendor’s single profile
  const vendorId = vendor.vendor_id;

  // Filter reviewData for this vendor
  const filteredVendorData = reviewData.filter(
    (review) => review.vendor.vendor_id === vendorId
  );

  const [averageRating, setAverageRating] = useState(null);
  // const [hireAgainTotal, sethireAgainTotal] = useState(null);
  // const [recommendAgainTotal, setrecommendAgainTotal] = useState(null);

  // const [createAccount, setCreateAccount] = useState(null)
  // const [accessToken, setAccessToken] = useState()

  const calculateAverageRating = (ratings) => {
    if (ratings.length === 0) return 0; // Handle no ratings

    // Sum all the rating scores
    const totalRating = ratings.reduce((acc, rating) => acc + rating.rating_score, 0);

    // Calculate the average
    const average = totalRating / ratings.length;

    // Round to the nearest integer (1 to 5 scale)
    return Math.round(average); // This will round the average to the nearest whole number
};

  useEffect(() => {
    if (!vendorOwnerData) {
        navigate('/');
        return; // Exit the function early to prevent further execution
    }

    // Calculate and set the average rating when vendorData changes
    if (vendorOwnerData.ratings) {
        const avg = calculateAverageRating(vendorOwnerData.ratings);
        setAverageRating(avg);
    }
}, [navigate, vendor]);

const viewMyPublicProfile = () => {
  const vendorId = vendor.vendor_id;

  // Filter reviewData for this vendor
  const filteredVendorData = reviewData.filter(
    (review) => review.vendor.vendor_id === vendorId
  );

  navigate('/vendor', {
    state: {
      user:user,
      vendor:vendor,
      filteredVendorData:filteredVendorData
    }
  });

};



  return (
    <div className='min-h-[screen] flex flex-col justify-between '>
      {
        <DashboardNav />
      }

      <div>
        <div className=' pt-[133px] md:pt-[152px] lg:pt-[160px] xl:pt-[150px] pb-[34px]  w-full flex flex-col gap-[50px] bg-custom-gradient'>
          <div className='  w-full flex flex-col  md:flex-row gap-[30px] justify-between items-start text-center md:text-start'>
            <div className='w-full px-[24px]  md:px-[32px] xl:px-[64px] flex flex-col gap-2  text-white  lg:mt-[0] mb-[34px]'>
              {/**Name, Stars and More*/}
              <div className='  w-full flex flex-col gap-2 md:justify-between'>
                <div className='flex flex-col md:flex-row md:gap-[10px] lg:gap-[16px] text-left items-start md:items-normal md:justify-between'>

                  {/* Large Screen Search */}

                  <div className=' flex flex-col gap-[6px] md:gap-0 '>
                    <h1 className=' font-black text-[25px]   leading-[33.75px] lg:text-huge xl:text-hb  text-white '>Hi {vendorOwnerData?.vendor_name} </h1>
                    <h2 className=' font-bold text-sm text-white '>Manage your vendor profile and track your performance </h2>
                    <div className='flex flex-col md:flex-row '>

                      {/* Star, Rating, Category, and Country */}
                      <div className='flex items-center gap-2 mt-[6px] flex-wrap md:flex-nowrap'>

                        {/* Star + Rating */}
                        {filteredVendorData?.length > 0 && (
                          <div className='flex items-center gap-1'>
                            <img
                              src={fullStar}
                              alt="star"
                              className='w-[20px] h-[20px]'
                            />
                            <span className='text-white font-medium text-sm'>
                              {averageRating !== null ? averageRating.toFixed(1) : "0.0"}
                            </span>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  {/* Social buttons */}
                  {/* <div className="mt-[13px] flex flex-row md:flex-col md:items-end gap-2  lg:flex-row">
                    Instagram button
                    {vendorOwnerData?.vendor_address && (

                      <a
                        href={vendorOwnerData.vendor_address}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-[140px] h-[52px] md:w-[130px] md:h-[42px] lg:w-[140px] lg:h-[52px] inline-flex items-center justify-center gap-[3px] border-[2px] border-white rounded-[80px] transition duration-300 group"
                      >
                        <span className="text-white font-bold text-[14px] transition duration-300">
                          Visit Page
                        </span>
                        <img
                          src={instagram}
                          alt="instagram"
                          className="size-[32px] transition duration-300"
                        />
                      </a>
                    )}

                    WhatsApp button
                    <a
                      href={`https://wa.me/${vendor?.vendor_phone_number}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[180px] h-[52px] md:w-[172px] md:h-[42px] lg:w-[180px] lg:h-[52px] inline-flex items-center justify-center gap-[3px] border-[2px] border-white rounded-[80px] transition duration-300 group"
                    >
                      <span className="text-white font-bold text-[14px] transition duration-300">
                        Message Vendor
                      </span>
                      <img
                        src={Whatsappimage}
                        alt="whatsapp"
                        className="size-[32px] transition duration-300"
                      />
                    </a>
                  </div> */}


                </div>
                {/* About vendor section */}
                {vendorOwnerData?.serviceDescription &&(
                <div className=" md:w-[428px] xl-w-[782px] text-left items-start flex flex-col gap-[10px]">
                  <h1 className=' font-bold text-[16px] mt-2'>About vendor</h1>
                  <h2 className='font-bold text-[16px] '>{vendorOwnerData?.serviceDescription}</h2>
                </div>)}


                {/* location icon, city of vendor, country of vendor */}
                <div className='flex w-fit top-[300px] mt-2 items-center gap-[4px] border bg-white h-6 rounded-[80px] px-2 py-[3px] justify-center'>
                  {/* Location Icon */}
                  <img src={locationicon} alt="location" className='w-[14px] h-[16px]' />
                  <p className='text-[#0079FF] text-[12px] font-bold'>
                    {vendorOwnerData?.city ? `${vendorOwnerData.city}, ` : ""}
                    {vendorOwnerData?.vendor_country?.vendor_country_name}
                  </p>
                </div>

                {/**Analytics */}
                {/* {filteredVendorData?.length > 0 && ( */}
                <div className='w-full sm:w-[400px] lg:w-[49%] xl:w-[52%] lg:left-[73px] h-[150px] md:h-[134px] lg:h-[184px] mt-12  flex flex-row px-[21px]  py-[18px] md:py-6 md:gap-[16px] lg:gap-[31px]   justify-between md:justify-evenly bg-white rounded-[20px] '>
                  {/**Average rating */}
                  <div className='flex flex-col items-left mb-[15px] lg:mb-0 lg:gap-2 '>
                    <h1 className=' flex gap-[10px]  font-black text-[#FEAD00] text-nowrap text-lg md:text-xl xl:text-[32px] '>{averageRating?.toFixed(1)}</h1>
                    <p className=' font-bold text-xs md:text-base xl:text-sm text-black text-start'>Average rating</p>
                    <div className='mt-[13px] lg:mt-2 flex flex-col md:flex-row md:gap-[6px]'>
                      <div className='flex items-center justify-between border border-[1px] text-[#E00505] font-bold border-[#E00505] bg-[#FFF0F0] py-[6px] px-[5px] w-[40px] rounded-[5px] h-6 text-xs'><ArrowDown size={'12px'} strokeWidth={4}   className='text-[#E00505] '/> 0</div>
                    <p className='text-ravash text-xs  xl:text-sm font-medium mt-[3px] text-start whitespace-nowrap'>this month</p>
                  </div>
                  </div>
                  <div className='w-auto border-t-none border-l xl:border-l-[2px] border-tcfgray mt-[7px]' />
                  {/**Total reviews */}
                  <div className='flex flex-col items-left mb-[15px] lg:mb-0 lg:gap-2'>
                    <h1 className=' flex gap-[10px]  font-black text-[#FEAD00] text-nowrap text-lg md:text-xl xl:text-[32px] '>  {vendorOwnerData?.ratings?.length || 0}</h1>
                    <p className=' font-bold text-xs md:text-base xl:text-sm text-black text-start'>Total reviews</p>
                    <div className='mt-[13px] lg:mt-2 flex flex-col md:flex-row md:gap-[6px]'>
                      <div className='flex  items-center justify-between border border-[1px] text-[#E00505] font-bold border-[#E00505] bg-[#FFF0F0] py-[6px] px-[5px] w-[40px] rounded-[5px] h-6 lg:gap-1 text-xs'><ArrowDown size={'12px'} strokeWidth={4}   className='text-[#E00505] '/> 0</div>
                    <p className='text-ravash text-xs xl:text-sm font-medium mt-[3px] text-start whitespace-nowrap'>this month</p>
                  </div>
                  </div>
                  <div className='w-auto border-t-none border-l xl:border-l-[2px] border-tcfgray mt-[7px]' />
                  {/* Profile views */}
                  <div className="flex flex-col items-left mb-[15px] lg:mb-0 lg:gap-2">
                    <h1 className="flex gap-[10px]  font-black text-[#FEAD00] text-nowrap text-lg md:text-xl xl:text-[32px] ">
                      2
                    </h1>
                    <p className=" font-bold text-xs md:text-base xl:text-sm text-black text-start">  Profile Views </p>
                    <div className='mt-[13px] lg:mt-2 flex flex-col md:flex-row md:gap-[6px]'>
                      <div className='flex items-center justify-between border border-[1px] text-[#5E9D00] font-bold border-[#5E9D00] bg-[#EDFFD1] py-[6px] px-[5px] w-[40px] rounded-[5px] h-6 text-xs '><ArrowUp size={'12px'} strokeWidth={4}   className='text-[#5E9D00] '/> 2</div>
                    <p className='text-ravash text-xs xl:text-sm font-medium mt-[3px] text-start whitespace-nowrap'>this month</p>
                  </div>
                  </div>
                  

                </div>

                {/* )} */}
                <div className='flex flex-col md:flex-row gap-3 mt-[25px] mb-[60px] w-full justify-center'>
                  {/* Write a Review Button */}
                  <button
                    className='w-full h-[44px] xl:h-[50px] bg-[#0079FF] text-white text-[18px] font-bold rounded-[80px] transition hover:bg-[#005FCC]'> Edit profie </button>

                  {/* Save Vendor Button */}
                  <button onClick={viewMyPublicProfile}  className='w-full  h-[44px] border-[white] text-[18px] text-[white] border-[1.5px] font-bold rounded-[80px] transition flex items-center justify-center gap-2.5'> View public profile </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default VendorDashboard;